import React from "react";

import AspectContainer from "../aspect-container/aspect-container";
import config from "../../config/config";

import { StorageContext } from "../storage/storage-context";

import { Theme } from "../../models/models";

const ThreeCard: React.FC<{cards: { img: string, title: string, body: string }[]}> = ({ cards }) => {

  const [storageContext, setStorageContext] = React.useContext(StorageContext);

  return (
    <div className="text-center">
      <div className="inline-flex flex-col md:flex-row flex-wrap justify-center">
        {
          cards.map((c, i) => (
            <div key={i} className={`flex flex-col md:max-w-[20rem] p-4 m-4 ${(storageContext.theme as Theme)?.cards.tertiary || `border border-slate-600 bg-slate-800`}`}>
              <AspectContainer aspectRatio="1.618:1">
                <img src={config.ASSETS[config.ENVIRONMENT] + c.img} className=" object-cover w-full h-full" alt="missing image" />
              </AspectContainer>
              <h1 className="text-left mt-4 text-lg p-1 font-secondary">{ c.title }</h1>
              <div className="flex-1 text-left p-1">
                { c.body }
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default ThreeCard;